module.exports = __webpack_public_path__ + "98ea2a325f66628c1ceb1abb104897b9.pdf";